<script>
import { isEqual } from 'lodash';

export default {
  data() {
    return {
      selectedDocuments: [],
    };
  },
  methods: {
    /**
     * document -> attachment url
     * eventVal -> true/false based on user selection of checkbox
     */
    selectSingleDocument(document, eventVal) {
      if (eventVal) {
        // user has selected the document
        this.selectedDocuments.push(document);
      } else {
        // user has unselected the document
        this.selectedDocuments =
          this.selectedDocuments &&
          this.selectedDocuments.filter(val => !isEqual(val, document));
      }
      this.selectedDocuments = [...this.selectedDocuments];
    },
    /**
     * start of multi select functionality in carton level
     */
    selectMultipleByDelivery(value, deliveryCartonsList) {
      deliveryCartonsList.forEach((deliveryDetail) => {
        this.selectMultiDocumentByTag(value, deliveryDetail.cartonIdsList);
      });
    },
    isAllSelectedByDeliveryId(deliveryCartonsList) {
      return deliveryCartonsList.every((deliveryDetail) => {
        const cartonsList = deliveryDetail.cartonIdsList;
        const cartonsWithAttachmentsList =
          cartonsList && cartonsList.filter(val => val.attachment);
        if (cartonsWithAttachmentsList) {
          const allCartonAttachmentUrls = cartonsWithAttachmentsList.map(
            val => val && val.attachment.document_url,
          );
          const selectedList = this.selectedDocuments.filter(
            val => val && allCartonAttachmentUrls.includes(val.document_url),
          );
          return allCartonAttachmentUrls.length
            ? selectedList.length === allCartonAttachmentUrls.length
            : true;
        }
        return false;
      });
    },
    selectMultiDocumentByTag(value, cartonsList) {
      const cartonsWithAttachmentsList =
        cartonsList && cartonsList.filter(val => val.attachment);
      const cartonAttachments =
        cartonsWithAttachmentsList &&
        cartonsWithAttachmentsList.map(val => val.attachment);
      if (cartonAttachments) {
        if (value) {
          this.selectedDocuments = this.selectedDocuments.concat(
            cartonAttachments,
          );
        } else {
          const unselectItems = cartonAttachments.map(
            val => val && val.document_url,
          );
          this.selectedDocuments = this.selectedDocuments.filter(
            val => val && !unselectItems.includes(val.document_url),
          );
        }
      }
    },
    isAllSelectedForTag(cartonsList) {
      const cartonsWithAttachmentsList =
        cartonsList && cartonsList.filter(val => val.attachment);
      if (cartonsWithAttachmentsList) {
        const allCartonAttachmentUrls = cartonsWithAttachmentsList.map(
          val => val && val.attachment.document_url,
        );
        const selectedList = this.selectedDocuments.filter(
          val => val && allCartonAttachmentUrls.includes(val.document_url),
        );
        return selectedList.length
          ? selectedList.length === allCartonAttachmentUrls.length
          : false;
      }
      return false;
    },
    /**
     * end of multi select functionality in carton level
     */
    downloadDocumentation() {
      this.selectedDocuments.forEach((document) => {
        try {
          if (document && document.document_url) {
            this.$store.dispatch('order/getDocumentFile', { params: document.document_url });
          }
        } catch (err) {
          console.log("cannot download link");
        }
      });
      if (this.selectedDocuments.length === 0) {
        this.$error({ message: 'Select the document type to download' });
      }
      this.selectedDocuments = [];
    },
    changeCopiesNumber(document, value) {
      const selectedDocIndex =
        this.selectedDocuments &&
        this.selectedDocuments.findIndex(
          val =>
            document.type === val.type &&
            document.delivery_id === val.delivery_id &&
            document.carton_id === val.carton_id &&
            document.indent_id === val.indent_id &&
            document.printing_level === val.printing_level &&
            document.item_id === val.item_id,
        );
      if (selectedDocIndex !== -1) {
        this.selectedDocuments[selectedDocIndex].no_copies = value;
      }
    },
    printDocumentation() {
      const printDocuments = this.selectedDocuments;
      this.$WebSocketPrinter.init(printDocuments, this);
      if (printDocuments.length) {
        if (this.$WebSocketPrinter.isConnected()) {
          this.$WebSocketPrinter.submit(this);
        } else {
          this.$error({ message: 'WebApp Hardware Bridge not running' });
          window.open(document.document_url);
        }
      }
      this.selectedDocuments = [];
    },
  },
};
</script>
